import React, { useContext, useState } from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './MonoHotelAvail.js';
import SearchOptions from '../../components/functional/SearchOptions';
import { Loading } from '@synergycms_core/components/functional/Loading';
import { AvailAccordion } from '../../components/functional/AvailMono/AvailAccordion';
import { MonoHotelAvailSummary } from '../../components/functional/MonoHotelAvailSummary';
import { AvailAlert } from '../../components/functional/AvailAlert';
import LoyaltyUserPoints from '../../components/functional/Loyalty/LoyaltyUserPoints.jsx';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { Map, List } from 'immutable';
import actions from '../../store/actions';
import ButtonCalendar from '../../components/functional/Calendar/ButtonCalendar';
import HotelInfoButton from '../../components/functional/HotelInfoButton/HotelInfoButton';
import { getSegmentsFilled, addScripts } from '../../utils';
import { RichText, Image } from '@synergycms_core/components/generic';
import {FIDELTOUR_CODE, STAR_TRAVELER_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import ModalInfoStarTraveler from '../../components/functional/Loyalty/StarTraveler/ModalInfoStarTraveler';
import CheckBox from '@synergycms_core/components/generic/CheckBox';
import ModalOnSelectRate from '../../components/functional/Loyalty/ModalOnSelectRate';
import Footer from '../../components/functional/Footer/Footer.jsx';
import { Button } from 'synergycms_core/src/components/generic';
import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";
import moment from 'moment';
import {
  getLoyaltyAvailDiscountPercent, roomsSelectionIsComplete,
  selectionIsComplete
} from '../../store/avail/availUtils';
import { AvailContext } from '../../components/functional/AvailMono/availContext.jsx';



const LoyaltyButton = compose(
  connect(
    (store, ownProps) => {
      return {
        advantages : store.getIn(['customer', 'loyalty', 'data', 'advantages'], null),
        starTravelerTiers : store.getIn(['customer', 'loyalty', 'data', 'tiers'], null)
      }
    },
  ),
  withContent('i18n')
)((props) => {
      const { type,loyaltyUser, classes , advantages, starTravelerTiers, content, theme } = props;
      const isMobile = theme && theme.width < 901;

      const LOYALTY_TYPES = {
        STAR_TRAVELER: {
          code: STAR_TRAVELER_CODE,
          url: "https://www.eurostarshotels.com",
          logo: 'stDefaultLogo'
        },
        FIDELTOUR: {
          code: FIDELTOUR_CODE,
          url: "https://www.fideltour.com",
          logo: 'memberOnlyBlue'
        }
      };
      const getLoyaltyType = (type) => {
        return Object.values(LOYALTY_TYPES).find(loyalty => loyalty.code === type);
      };

      const getLoyaltyLogoText = (key) => {
        const translated = content ? content.t(`_%${key}%_`) : '';
        return translated.trim() !== '' && translated !== key ? translated : null;
      };

      const loyaltyLogoText = getLoyaltyLogoText(isMobile ? 'loyalty_logo_text_mobile' : 'loyalty_logo_text');
      const loyaltyType = getLoyaltyType(type);
      const programLogo = type === STAR_TRAVELER_CODE ? loyaltyType.logo+'Hz': loyaltyType.logo;

      if(!loyaltyUser) {
        if (loyaltyType) {
          return (
            <div className={classes.buttonLogo} >
              {type === STAR_TRAVELER_CODE &&
              <ModalInfoStarTraveler
                id={'td-d1-startraveler-modal-00'}
                advantages={advantages}
                starTravelerTiers={starTravelerTiers}
                buttonContent={() => <span><Image innerStyle={classes.starTravelerTabLogo} svg={programLogo} /></span>}
              />
              }
              {type === FIDELTOUR_CODE && (
                loyaltyLogoText ? (
                  <RichText
                    text={loyaltyLogoText}
                    translate={true}
                    dangerouslySetInnerHTML={true}
                    innerStyle={classes.loyaltyTabLogo}
                  />
                ) : (
                  <Image innerStyle={[classes.starTravelerTabLogo, classes.loyaltyLogo].join(' ')} svg={programLogo}/>
                )
              )}
            </div>
          );
        }
      }
      return null;
    });

const AdvantagesFideltour = compose(
  connect(
    (store) => {
      return {
        advantages : store.getIn(['customer', 'loyalty', 'data', 'advantages'], null)
      }
    },
  ),
  withContent('i18n')
)(({ showMore, toggleMore, isExpanded = false,advantages,classes }) => {
  const advantagesList = advantages ? advantages : List();

  return (
    <div className={classes.advFideltour}>
      <ul className={classes.advantagesBox}>
        {advantagesList.size > 0 &&
          advantagesList.slice(0, 3).map((adv) => {
            const benefitIconSyn = adv.get('icon')
              ? `${process.env.URL_ENVIRONMENT}/api/medias/${adv.get('icon')}`
              : false;

            return (
              <li className={classes.advantageBox} key={adv.get('id')}>
                {benefitIconSyn && (
                  <div className={classes.advantagesIcons}>
                    <Image
                      svg={benefitIconSyn}
                      remoteSvg
                      innerStyle={classes.advantageIcon}
                    />
                  </div>
                )}

                {adv.get('title') && (
                  <RichText
                    text={adv.get('title')}
                    innerStyle={classes.advantagesTextBold}
                    ucFirst
                  />
                )}
              </li>
            );
          })
        }
      </ul>

      {!isExpanded && (
        <div className={classes.advantagesArrowBox}>
          <Button
            innerStyle={classes.langSelectorBtn}
            onClick={toggleMore}
            rightIcon={{
              svg: 'dropDownArrow',
              innerStyle: [
                classes.langSelectorIcon,
                showMore ? classes.rotate180 : classes.rotate0
              ],
            }}
          />
        </div>
      )}
    </div>
  );
});


const LoyaltyTab = compose(
  connect(
    (store, ownProps)=> {
      return {
          type : store.getIn(['customer', 'loyalty', 'data', 'loyalty','code'], null),
          loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
      }
    }
  ),
  withContent('i18n')
)((props) => {
      const {classes, loyaltyUser, loyaltyDiscount, type, isChecked, theme, content, hotelConfig } = props;
      const { toggleAvailType, loyaltyEnabled, handleModalCloseCheckboxChange } = useContext(AvailContext);
      const isMobile = theme && theme.width < 901;

      const getTextValue = () => {
        if (type === STAR_TRAVELER_CODE) {
          return loyaltyEnabled
            ? '_%10% dto. miembros activo%_'
            : '_%10% dto. miembros desactivado%_'
        } else if (type === FIDELTOUR_CODE) {
          return loyaltyEnabled
            ? '_%tarifas para miembros%_'
            : '_%ver tarifas para miembros%_';
        }

        return null;
      }

      const determineCheckboxId = () => {
        if (type === STAR_TRAVELER_CODE) {
          return loyaltyEnabled
            ? 'td-d1-startraveler-check-00'
            : 'td-d1-startraveler-check-01';
        }

        return null;
      };

      const [showMore, setShowMore] = useState(false);
      const toggleMore = () => setShowMore(prev => !prev);
      const loyaltyImageBanner = content ? content.t('_%loyalty_image_banner%_') : '';
      const showSeparatorBanner = hotelConfig.getIn(['loyalty_banner','show_separator_banner'], false);

      if (!loyaltyUser && loyaltyDiscount) {
        return (
          <div
            className={type === STAR_TRAVELER_CODE ? classes.containerRateStarTraveler : classes.containerRateFidelTour}
            style={loyaltyImageBanner ? { backgroundImage: `url(${loyaltyImageBanner})`, backgroundSize: 'cover' } : undefined}
          >
            <div className={[classes.rateBox, type === FIDELTOUR_CODE ? classes.rateBoxFidelTour : ''].join(' ')}>
              <LoyaltyButton type={type} loyaltyUser={loyaltyUser} classes={classes} theme={theme} />
              {type === FIDELTOUR_CODE && (
                <AdvantagesFideltour
                  classes={classes}
                  showMore={showMore}
                  toggleMore={toggleMore}
                />
              )}
              {!isMobile && showSeparatorBanner && <div className={classes.separator}></div>}
              <div className={[classes.toggleCheck, type === FIDELTOUR_CODE ? classes.hiddeToggleCheck : ''].join(' ')}>
                <div className={classes.loyaltyText}>
                  <RichText
                    translate={true}
                    text={getTextValue()}
                    ucFirst={true}
                    dangerouslySetInnerHTML={true}
                    innerStyle={classes.loyaltyTextBanner}
                  />

                  {type === FIDELTOUR_CODE &&
                    <ModalOnSelectRate loyaltyEnabled={true} closeCallback={handleModalCloseCheckboxChange}>
                      <Button
                        id="td-d1-confirm-price-01"
                        richText={
                          theme.width >= 902 && {
                            ucFirst: true,
                            text: '_%¿Ya eres miembro? Haz Click Aquí%_',
                            innerStyle: classes.loyaltyLoginButton,
                            translate: true
                          }
                        }>
                      </Button>
                    </ModalOnSelectRate>
                  }
                </div>
              <label
                className={`${classes.switch} ${loyaltyUser ? classes.disabled : ''} ${type === FIDELTOUR_CODE ? classes.widthFideltour : ''}`}>
                  <CheckBox
                    onChange={toggleAvailType}
                    innerStyle={`${classes.slider} ${type === STAR_TRAVELER_CODE ? classes.sliderRound : classes.loyaltySliderRound} ${isChecked ? '' : classes.nocheck}`}
                    id={determineCheckboxId()}
                    tabIndex={-1}
                  />
                </label>
              </div>
            </div>
            {type === FIDELTOUR_CODE && showMore && (
              <div className={classes.advantagesFideltourExpaned}>
                <AdvantagesFideltour
                  classes={classes}
                  showMore={showMore}
                  toggleMore={toggleMore}
                  isExpanded={true}
                />
              </div>
            )}

            {type === FIDELTOUR_CODE &&
              <div className={[classes.toggleCheck, classes.toggleCheckFidelTour].join(' ')}>
                <div className={classes.loyaltyText}>
                  <RichText
                    translate={true}
                    text={'_%beneficios de miembros aplicados%_'}
                    ucFirst={true}
                    dangerouslySetInnerHTML={true}
                    innerStyle={classes.loyaltyTextFideltour}
                  />
                </div>

                <label className={`${classes.switch} ${loyaltyUser ? classes.disabled : ''}`}>
                  <CheckBox
                    onChange={toggleAvailType}
                    innerStyle={`${classes.slider} ${classes.loyaltySliderRoundV2} ${isChecked ? '' : classes.nocheck}`}
                    id={determineCheckboxId()}
                    tabIndex={-1}
                  />
                </label>
              </div>
            }
          </div>
        );
      }
      return null;
    });

const MonoHotelAvail = class MonoHotelAvail extends React.Component {
  static displayName = 'MonoHotelAvail';

  constructor(props) {
    super(props);

    this.cx = props.theme.bind();

    let visibleSegment = 1;
    if (!props.hasSelectionAvail && props.roomRatesSelected.some(value => value.get('price'))) {
      props.resetReservationRequest();
    } else if (props.hasSelectionAvail) {
      let roomRatePending = false;
      props.roomRatesSelected.forEach(value => {
        if (!roomRatePending && value.get('price', false) === false) {
          roomRatePending = value;
        }
      });
      visibleSegment = roomRatePending ? parseInt(roomRatePending.get('idx'), 10) : false;
    }

    const { hotelDetails, referer } = this.props;
    const scripts = hotelDetails.getIn(['extended_scripts'], undefined);
    if (scripts && scripts.size > 0 && referer) {
      addScripts(hotelDetails, referer, 'avail');
    }

    if (visibleSegment === 1 && (props.roomsAvail)?.get('success') !== false) {
      (props.roomsAvail).forEach((rooms, index) => {
        if (!roomsSelectionIsComplete(rooms) && visibleSegment === 1) {
          visibleSegment = index + 1;
        }
      });
    }
    
    if(visibleSegment === 1 && selectionIsComplete(props.roomsAvail,true)) {
      visibleSegment = false;
    }
    
    this.state = {
      params: this.props.params,
      visibleSegment: visibleSegment,
      isChecked: props.availTypeSelected === 'loyalty',
    };
  }

  goBackClick = (forceCity = false) => e => {
    e.preventDefault();
    const { config } = this.props;
    let hotelsCity;
    let hotelsCountry;
    let cityId = false;
    let countryId = false;
    if (config.stepType === 'mono') {
      if (config.city.size > 0 || forceCity) {
        cityId = forceCity ? forceCity : this.props.config.city.get('id');
        hotelsCity = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('city_id') === cityId)
          .toJS()
          .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());
      } else if (config.country.size > 0) {
        countryId = this.props.config.country.get('id');
        hotelsCountry = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('country_id') === countryId)
          .toJS()
          .reduce((hotelsCountry, hotel) => hotelsCountry.concat([hotel.id]), List());
      } else {
        cityId = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .find(h => h.get('id') === config.hotelId)
          .get('city_id');

        hotelsCity = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('city_id') === cityId)
          .toJS()
          .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());
      }
    }
    this.props.goBack(hotelsCity || hotelsCountry, cityId, countryId, config);
  };

  bestAvailPrice = (avail,manual = false) => {
    const showTaxes = this.props.hotelDetails.get("show_taxes");
    let bestPrice = null;
    avail && avail.find(roomTypes => {
      return roomTypes && roomTypes.find(roomType => {
        return roomType && roomType.get('boards').find(board => {
          return board && board.find(refType => {
           if (manual || refType.get('best_price', false) === true) {
              refType.get("days").forEach((day) => {
                const price = day.get(showTaxes ? "price_tax" : "price");
                bestPrice = bestPrice === null || bestPrice > price ? price : bestPrice;
              });
              if(!manual) return true;
           }
           return false;
          });
        });
      });
    });
    return bestPrice;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(!nextProps.segmentsFilled && prevState.visibleSegment !== 1){
      return { visibleSegment : 1 };
    }
    else return null;
  }

  setVisibleSegment = (segment) => {
    const { roomsAvail, segmentsFilled } = this.props;
    if (segment === false && roomsAvail.size !== segmentsFilled) {
      segment = segmentsFilled + 1;
    }
    this.setState(
      {
        visibleSegment: segment
      },
      () => {
        const visibleSegment = this.state.visibleSegment || false;
        const ref = this.refs['accordion' + visibleSegment.toString()];
        if (ref) {
          ref.scrollIntoView();
          window.scrollBy(0, -65);
        } else {
          window.scrollTo(0, 0);
        }
      }
    );
  };

  handleCheckboxChange = (event) => {
    const isChecked = !this.state.isChecked //!event.target.checked;
    this.setState(
      { isChecked },
      () => {
          this.props.getAvailType(isChecked ? 'loyalty' : 'standard')
      }
    );
  };

  handleModalCloseCheckboxChange = (value) => {
    if(this.state.isChecked) {
      this.setState({ isChecked: value });
      this.handleCheckboxChange();
    }
  }

  handleShowTabs = (tab) => () => {
    this.setState({ isChecked: tab === 1 });
  };

  componentDidMount() {
    console.log("remount");
    this.props.triggerEvent();
  }
  

  render() {
    const {
      maxNights,
      roomsAvail,
      isAlterSearch,
      stayLength,
      segmentsFilled,
      roomRatesSelected,
      theme,
      hotelDetails,
      minNightsError,
      langCode,
      webType,
      loyaltyUser,
      destinationHasAvailability,
      loyalty,
      loyaltyDiscount,
      rateSelected,
      hasSelectionAvail,
      params,
      content,
      hotelConfig
    } = this.props;

    const {
      isChecked,
    } = this.state;


    const { classes } = theme.styles;
    
    let alertReason = 'no_avail';
    let alertObjVars = {};
    let urlHotel = hotelDetails.getIn(['slug'], ['website'], ['']);

    const dateStart = moment(params.get('date'));
    const isDateInvalid = dateStart.startOf('day').isBefore(moment().startOf('day'));

    if (isDateInvalid) {
      alertReason = 'invalid_date';
    } else if (roomsAvail.get('success') === false) {
      if (stayLength >= maxNights) {
        alertReason = 'max_nights';
      } else if (minNightsError) {
        alertReason = 'min_nights';
        alertObjVars = { value: minNightsError };
      }
    }

    const existLoyaltyAvail = !!loyaltyDiscount;
    const loyaltyEnabled = !!loyalty && ((this.state.isChecked) || loyaltyUser);
    const showMonoHotelSummary = selectionIsComplete(roomsAvail) && hasSelectionAvail;


    if (roomsAvail.get('success') !== false) {
      return (
        <AvailContext.Provider
          value={{
            existLoyaltyAvail,
            loyaltyEnabled,
            toggleAvailType : this.handleCheckboxChange,
            handleModalCloseCheckboxChange : this.handleModalCloseCheckboxChange,
            isChecked:this.state.isChecked
          }}>
          <div className={classes.defaultStyle}>
            <LoyaltyUserPoints />
            <SearchOptions innerStyle={['monoHotelSearchOptions']} />
            
            <div>
              {this.props.theme.deviceType !== 'DESK' && (
                <div className={[classes.calendarInfoButton, this.cx({wiCalendarInfoButton: webType === 'WI',destiCalendar: destinationHasAvailability})].join(' ')}>
                  <ButtonCalendar />
                  {webType !== 'WI' && (
                    <div className={classes.seeHotelWeb}>
                      <HotelInfoButton langCode={langCode} urlHotel={urlHotel} deviceType={this.props.theme.deviceType} />
                    </div>
                  )}
                </div>
              )}

              <LoyaltyTab
                isChecked={isChecked} 
                theme={theme}
                loyaltyDiscount={loyaltyDiscount}
                hotelConfig={hotelConfig}
                classes={classes} />
              <ul className={classes.listContainer}>
                {!!isAlterSearch && <AvailAlert type={'alter_avail'} showCalendar={false} showRelated={false}/>}
                {roomsAvail.map((segmentAvail, key) => {
                  return (
                    <li key={key} className={classes.roomList}
                        ref={'accordion' + (key + 1).toString()}>
                          <AvailAccordion
                            setVisibleSegment={this.setVisibleSegment}
                            visibleSegment={key + 1 === this.state.visibleSegment}
                            segmentAvail={segmentAvail}
                            totalSegments={roomsAvail.size}
                            segment={key + 1}
                            hasSelectionAvail={hasSelectionAvail}
                            isFirstSegment={key === 0}
                          />
                    </li>
                  );
                })}
              </ul>
            </div>
            <Footer />
            <MonoHotelAvailSummary
              totalSegments={roomsAvail.size}
              segmentsFilled={segmentsFilled}
              roomRatesSelected={roomRatesSelected}
              show={showMonoHotelSummary}
            />
          </div>
         </AvailContext.Provider>
      );
    }

    return (
      
        <div className={classes.defaultStyle}>
          <SearchOptions innerStyle={['monoHotelSearchOptions']}/>
          <div>
            <AvailAlert type={alertReason} objVars={alertObjVars}/>
          </div>
          <div className={classes.footer}>
            <Footer />
          </div>
        </div>
     
    );
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getAvailType:  (resetReservationRequest) => (rate) => {
      resetReservationRequest();
      dispatch(actions.customer.availTypeSelected.set(rate))
      dispatch(actions.avail.getAvailAsync())
        .then(()=> dispatch(actions.avail.getFlexibleAsync()))
        .then(()=> dispatch(actions.avail.getAvailParsed()))
    },
    resetReservationRequest: () => {
      dispatch(actions.customer.roomPreferences.initialize());
      dispatch(actions.customer.reservation.set(Map()));
      dispatch(actions.customer.reservationRequest.initialize());
    },
    triggerEvent: () => {
      
      dispatch(actions.events.trigger('show_avail'));
    },
    goBack: (totalSegments, availServices, group) => (hotelsIds, cityId, countryId, config) => {
      
      dispatch(actions.customer.currentHotel.clear());
      if (cityId) {
        dispatch(actions.customer.params.updateParams(Map({ hotelId: null, hotels: hotelsIds, selection_avail: null, city_id: cityId })));
      } else if (countryId) {
        dispatch(actions.customer.params.updateParams(Map({ hotelId: null, hotels: hotelsIds, selection_avail: null, country_id: countryId })));
      }
      dispatch(actions.customer.currentHotels.set(hotelsIds));
      dispatch(actions.customer.step.prev());
      dispatch(actions.router.update());

      

      return Promise.all([
        dispatch(actions.hotels.getAsync()),
        dispatch(actions.customer.loyalty.getDescriptiveAsync(group))
          .then((result)=> {
            return dispatch(actions.avail.getAvailAsync(result.get(group, null), [], false));
          })
      ]).then(() => {
        dispatch(actions.customer.orderBy.set(group === 'eurostarshotels' ? 'proximity' : 'price'));
        dispatch(actions.customer.filters.get());
        dispatch(actions.availServices.getAsync());
      }).tap(dispatch(actions.events.trigger('show_avail')));
    },
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const params = store.getIn(['customer', 'params', 'params'], undefined);
  const availTypeSelected = store.getIn(['customer', 'avail_type_selected']);

  var roomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono","query_params"])]),
    'response'
  ]);


  /***** FILTER AVAIL ******/
  const selectionAvail = store.getIn(['customer', 'params', 'params', 'selection_avail'], null);
  
  const alterSearch = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono", "query_params"])]),
    'is_alter_search'
  ]);

  const isAlterSearch = !!alterSearch;

  const roomRatesSelected = store.getIn(['customer', 'reservation_request', 'blocks']);
  const segmentsFilled = roomRatesSelected?.size > 0 ? getSegmentsFilled(roomRatesSelected) : 0;
  const isSelectionCompleted = !selectionAvail || segmentsFilled > 0;
  const currentStep = store.getIn(['customer', 'step', 'current_step', 'code'], null);
  const jumpSteps = store.getIn(['customer', 'step', 'jump_steps'], List());
  const webType = store.getIn(['customer', 'web_type'], false);
  const minNightsError =
    store.getIn([
      'avail',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono", "query_params"])]),
      'raw_response',
      0,
      'code'
    ], false) === 362 &&
    store.getIn([
      'avail',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono", "query_params"])]),
      'raw_response',
      0,
      'error_param'
    ], false);
  const loyalty = store.getIn(['customer', 'loyalty', 'data', 'loyalty'], null);
  

  let loyaltyDiscount = getLoyaltyAvailDiscountPercent(store);

  const hotelGroup = store.getIn(['hotels', hotelId, 'group']);

  const availCacheQueryParams = store.getIn(['customer', 'params', 'avail_cache_query_params'], Map());

  const availCache = store.getIn(['availCache', hotelGroup, availCacheQueryParams], false);

  let city = Map();
  let country = Map();

  const startDate = store.getIn(['customer', 'params', 'url_params', 'start'], false);
  const endDate = store.getIn(['customer', 'params', 'url_params', 'end'], false);

  const getDateRange = (start, end) => {
    const range = [];
    if(start && end ){
      let currentDate = moment(start);
      const finalDate = moment(end);

      while (currentDate.isSameOrBefore(finalDate, 'day')) {
        range.push(currentDate.format('YYYY-MM-DD'));
        currentDate.add(1, 'day');
      }
    }
    return range;
  };

  const dateRange = getDateRange(startDate, endDate);

  let destinationHasAvailability = false;

  if(webType === 'PORTAL') {
    country =
      params &&
      params.get('country_id') &&
      store.getIn(['hotels', 'hotels_info', 'countries']).find(country => {
        return country.get('id') === parseInt(params.get('country_id'), 10);
      });

    city =
      params &&
      params.get('city_id') &&
      store.getIn(['hotels', 'hotels_info', 'cities']).find(city => {
        return city.get('id') === parseInt(params.get('city_id'), 10);
      });

    if (availCache) {
      destinationHasAvailability = true;
      dateRange.forEach((date) => {
        if (availCache.getIn([date, 'count'], 0) < 2) {
          destinationHasAvailability = false;
          return;
        }
      });
    }
  }

  return {
    params: store.getIn(['customer', 'params', 'params']),
    resolveAvail:
      store.getIn(['customer', 'params', store.getIn(["availQuery", "mono","query_params"])]) ===
        store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono","base_query_params"])])
        ? true
        : undefined,
    roomRatesSelected: roomRatesSelected,
    maxNights: store.getIn(['hotels', hotelId, 'max_avail']) || 31,
    hotelInfo: store.getIn(['hotels', hotelId, 'success']),
    roomsAvail: roomsAvail,
    hotelDetails: store.getIn(['hotels', hotelId], undefined),
    isAlterSearch: isAlterSearch,
    minNightsError: minNightsError,
    stayLength: store.getIn(['customer', 'params', 'params', 'stay_length']),
    referer: store.getIn(['customer', 'params', 'url_params', 'id_referer'], false),
    segmentsFilled: segmentsFilled,
    hasSelectionAvail: selectionAvail,
    isSelectionCompleted: isSelectionCompleted,
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    currentStep: currentStep,
    jumpSteps: jumpSteps,
    webType: webType,
    loyalty: loyalty,
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
    loyaltyType: loyalty && loyalty.get("code", null),
    availTypeSelected: availTypeSelected,
    loyaltyDiscount: loyaltyDiscount,
    cities: store.getIn(['hotels', 'hotels_info', 'cities'], List()),
    hotels: store.getIn(['hotels']),
    hotelId: hotelId,
    destinationHasAvailability: destinationHasAvailability,
    config: {
      stepType: store.getIn(['customer', 'step', 'current_step', 'type'], null),
      city: city,
      country: country,
      hotels: store.getIn(['hotels']),
      hotelId: hotelId,
      currentStep: currentStep,
    },
    group: store.get("group", false),
    availServices: store.getIn(['availServices']),
    hotelConfig: contextualizeAppConfig(store, hotelId),
  };
  
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  getAvailType: dispatchProps.getAvailType(dispatchProps.resetReservationRequest),
  goBack: dispatchProps.goBack(stateProps.totalSegments, stateProps.availServices, stateProps.group)
});

const fragment = props => {

  const engineSygyData = window.frontLoader || window.engine_sygy_data;
  const { webType } = props;
  const group = engineSygyData && engineSygyData.group;
  const corporateLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 1 ? window.LoginUser : null;
  const loyaltyLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 2 ? window.LoginUser : null;
  const userLogIn = (corporateLogin && corporateLogin.usuario !== 'NoLogin') || (loyaltyLogin && loyaltyLogin.usuario !== 'NoLogin');

  return (
  <React.Fragment>
    <Loading
      richText={{
        ucFirst: true,
        innerStyle: ['descriptionText'],
        text: '_%estamos buscando los mejores precios para ti%_',
        translate: true
      }}
        showLoyaltyBanner={webType === 'PORTAL' && group === 'eurostarshotels' && !userLogIn}
    />
  </React.Fragment>
);
};
//MonoHotelAvail.whyDidYouRender = true
const MonoHotel = compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  withThemeJSS({ styleFile, index: 100, link: true}),
  withContent('i18n')
)(MonoHotelAvail);



export default MonoHotel;